import { render, staticRenderFns } from "./RouteStrategy.vue?vue&type=template&id=457929d8&scoped=true"
import script from "./RouteStrategy.vue?vue&type=script&lang=js"
export * from "./RouteStrategy.vue?vue&type=script&lang=js"
import style0 from "./RouteStrategy.vue?vue&type=style&index=0&id=457929d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457929d8",
  null
  
)

export default component.exports